import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapMutations, mapState, mapActions } from 'vuex';
import ResourceUploader from './resource-uploader.vue';
import { groupItemMixin } from '@/views/creative/mixin/index.js';
import useFileToExchangeResource from '@/views/creative/utils/use-file-to-exchange-resource';
import categoryMixin from '@/views/creative/mixin/category';
import { getFileName, isJpg, isPng } from '@com/utils/file';
import _ from 'lodash';
import { getFilterConfigForFilter } from '@/store/creative/common/resource';
import filter from '@com/image/filter';
import { uploadFile } from '@/api/common/upload';
import { removeBase64Prefix } from '@com/utils/base64';
import { getModelTexType } from '@/store/creative/template/model/util';
import useIdToFindResourceList from '@/views/creative/utils/use-id-to-find-resource-list.js';
import { getJsonModelPath, isCocosModelResource } from '@/views/creative/utils';
import { getCommonAssetModelInfo } from '@/api/common/asset';
import { getCommonComponentList } from '@/api/common/asset';
import { assetCallbackModel } from '@/store/creative/asset';
import { isPresetPrefix as _isPresetPrefix } from '@/views/creative/utils/preset-utils';
import { tabNameList } from '@com/components/resource-manager/config';
import isMaterialWarehouse from '@/common/is-warehouse';

export default {
  components: {
    ResourceUploader: ResourceUploader
  },

  mixins: [groupItemMixin, categoryMixin],

  props: {
    category: {
      type: Object,
      required: true
    },
    resource: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    buttonAttrs: {
      type: Object
    }
  },

  data: function data() {
    return {
      uploading: false
    };
  },


  computed: _extends({}, mapState({
    template: function template(state) {
      return state.creative.template;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    hasMvPlayable: function hasMvPlayable(state) {
      return state.creative.template.hasMvPlayable;
    }
  }), {
    resourceList: function resourceList() {
      if (this.templateConfig && this.category) {
        var list = useIdToFindResourceList({
          resource: this.templateConfig.resource,
          id: this.category.id
        });
        return list;
      }
      return [];
    },
    isCocosModel: function isCocosModel() {
      return this.isModel && this.resourceList && isCocosModelResource(this.resourceList[0]);
    },
    innerButtonAttrs: function innerButtonAttrs() {
      return _extends({
        text: this.$t('playTurbo.custom.resourceDialog.handlerRelated.update'),
        disabled: !this.isUpdatable
      }, this.buttonAttrs);
    },
    isUpdatable: function isUpdatable() {
      if (this.hasPermission('resource.basic-resource-updatable')) return true;
      return this.resource && this.resource.is_basic !== 1;
    },
    basicResource: function basicResource() {
      return this.resourceList.find(function (item) {
        return item.is_basic === 1;
      });
    },
    baseResourcePreviewUrls: function baseResourcePreviewUrls() {
      return _.get(this.basicResource, 'preview_urls_for_live_preview') || [];
    },


    // 模型图片格式
    modelTexType: function modelTexType() {
      return getModelTexType(this.baseResourcePreviewUrls);
    },
    isPresetPrefix: function isPresetPrefix() {
      return this.resourceList && _isPresetPrefix(this.resourceList[0].prefix);
    }
  }),

  methods: _extends({}, mapMutations({
    openAddRepositoryResourceDialog: 'creative/template/openAddRepositoryResourceDialog',
    openAddLocalResourceDialog: 'creative/template/openAddLocalResourceDialog',
    updateCurrentResource: 'creative/template/updateCurrentResource',
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    closeEditResourceDialog: 'creative/template/closeEditResourceDialog',
    updateResourceManagerDialog: 'creative/asset/updateResourceManagerDialog'
  }), mapActions({
    updateResource: 'creative/template/updateResource',
    dispatchConversionEvent: 'creative/template/model/dispatchConversionEvent',
    openModelEditorByGltf: 'creative/modelEditor/openModelEditorByGltf',
    replaceAnimationByGltf: 'creative/modelEditor/replaceAnimationByGltf'
  }), {
    open: function open() {
      var _this = this;

      this.updateCurrentCategory(this.category);
      this.updateCurrentResource(this.resource);
      if (this.isModel) {
        if (this.isCocosModel) {
          this.openAddLocalResourceDialog({ action: 'update' });
        } else {
          this.dispatchConversionEvent({
            texType: this.modelTexType,
            callback: function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
                var newResource;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        newResource = useFileToExchangeResource({
                          file: file,
                          id: _this.currentResource.id,
                          category: _this.category,
                          isZip: _this.isZip,
                          isModel: _this.isModel
                        });

                        _this.updateResource(_extends({}, newResource, {
                          id: _this.currentResource.id
                        }));

                      case 2:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function callback(_x) {
                return _ref.apply(this, arguments);
              };
            }()
          });
        }
      } else if (this.category.isRepository) {
        this.openAddRepositoryResourceDialog({ action: 'update' });
      } else {
        this.openAddLocalResourceDialog({ action: 'update' });
      }
    },
    handleUploadSuccess: function handleUploadSuccess(_ref2) {
      var _this2 = this;

      var file = _ref2.file,
          resource = _ref2.resource;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var newResource, isImage, filters, originalUrl, urls, res, _res$data$data, file_path, md5, url;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!resource) {
                  _context2.next = 15;
                  break;
                }

                newResource = _extends({}, resource, {
                  id: _this2.resource.id,
                  file_md5: file.md5,
                  resource_origin: 'local',
                  category_id: _this2.category.id
                });
                isImage = isPng(newResource.file_url) || isJpg(newResource.file_url);
                // 如果是图片，则补上滤镜处理

                if (!isImage) {
                  _context2.next = 14;
                  break;
                }

                filters = getFilterConfigForFilter(newResource.extra.config.filters, newResource.extra.config.enableFillColor);
                originalUrl = newResource.extra.origin_file_url;
                _context2.next = 8;
                return filter({
                  urls: [originalUrl],
                  filters: filters
                });

              case 8:
                urls = _context2.sent;
                _context2.next = 11;
                return uploadFile({
                  file_base64: removeBase64Prefix(urls[0]),
                  filename: getFileName(originalUrl),
                  quality: 70
                });

              case 11:
                res = _context2.sent;
                _res$data$data = res.data.data, file_path = _res$data$data.file_path, md5 = _res$data$data.md5, url = _res$data$data.url;

                newResource = _extends({}, newResource, {
                  file_path: file_path,
                  file_md5: md5,
                  file_url: url
                });

              case 14:

                if (_this2.resourceList.filter(function (item) {
                  return item.action !== 'del';
                }).some(function (item) {
                  return item.file_md5 === newResource.file_md5;
                })) {
                  _this2.$message({
                    message: _this2.$t('playTurbo.custom.resourceDialog.uploadWarning'),
                    type: 'error'
                  });
                } else {
                  _this2.updateResource(_extends({}, newResource));
                }

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleOpenAssetDialog: function handleOpenAssetDialog() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var DEFAULT_RULES, defaultTab, tabKeyList, maxSize, model, modelInfo;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.updateCurrentCategory(_this3.category);
                _this3.updateCurrentResource(_this3.resource);
                // 点击之前触发 before-upload
                _this3.$emit('before-upload');
                DEFAULT_RULES = {};
                defaultTab = '';
                tabKeyList = [];
                maxSize = 0;
                model = {
                  order: '-updated_time',
                  formats: ['zip']
                };

                if (!(_this3.isModel || _this3.isCocosModelAnimation)) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 11;
                return getCommonAssetModelInfo({
                  name: _this3.category.prefix
                });

              case 11:
                modelInfo = _context4.sent;

                maxSize = 5 * 1024 * 1024;
                model.size_max = maxSize;
                model.skeleton_type = modelInfo.data.data.skeleton_type;
                DEFAULT_RULES.model = {
                  size_max: maxSize,
                  formats: ['zip']
                };
                model.type = _this3.isCocosModelAnimation ? 'action' : 'model';
                defaultTab = _this3.isCocosModelAnimation ? tabNameList.commonAction : tabNameList.commonModel;
                if (_this3.isCocosModelAnimation) {
                  tabKeyList = [tabNameList.commonAction];
                } else if (isMaterialWarehouse()) {
                  tabKeyList = [tabNameList.commonModel];
                } else {
                  tabKeyList = [tabNameList.commonModel, tabNameList.assetModel];
                }

              case 19:
                _this3.updateResourceManagerDialog({
                  visible: true,
                  model: model,
                  defaultTab: defaultTab,
                  tabKeyList: tabKeyList
                });
                // 因为每次触发回调事件不一样。每次都重写 callback
                assetCallbackModel.submit = function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file) {
                    var submitCallback, res, isGm, params, changeResourceByGltf;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            // 提交事件执行结束的回调
                            submitCallback = function submitCallback() {
                              assetCallbackModel.loading = false;
                            };
                            // 确保多次点击不会多次触发


                            if (!assetCallbackModel.loading) {
                              _context3.next = 3;
                              break;
                            }

                            return _context3.abrupt('return');

                          case 3:
                            assetCallbackModel.loading = true;
                            // 关闭掉模型库弹框
                            _this3.updateResourceManagerDialog({
                              visible: false
                            });
                            _context3.prev = 5;
                            _context3.next = 8;
                            return getCommonComponentList({
                              tool: 1,
                              id: file.file.id
                            });

                          case 8:
                            res = _context3.sent;

                            if (!(res.data && res.data && res.data.data.total === 0)) {
                              _context3.next = 12;
                              break;
                            }

                            submitCallback();
                            return _context3.abrupt('return', _this3.$message.error(_this3.$t('playTurbo.custom.resourceUploader.assetNotExist')));

                          case 12:
                            _context3.next = 19;
                            break;

                          case 14:
                            _context3.prev = 14;
                            _context3.t0 = _context3['catch'](5);

                            submitCallback();
                            console.error(_context3.t0);
                            return _context3.abrupt('return', _this3.$message.error(_this3.$t('playTurbo.custom.resourceUploader.assetNotExist')));

                          case 19:

                            if (_this3.isModel || _this3.isCocosModelAnimation) {
                              // 是否通用模板
                              // 1. 通过url参数进入带templateType页面
                              // 2. 使用通用模板制作的项目
                              // 3. 模板编辑页
                              isGm = _this3.template.isGeneralTemplateService;
                              params = {
                                fileUrl: file.file.file_url,
                                filePath: _this3.resource.real_file_path,
                                mod: isGm ? 'gm' : 'dm',
                                model: getJsonModelPath(_this3.resourceList[0].file_path),
                                tplId: _this3.template.templateId,
                                preset: _this3.isPresetPrefix ? 1 : 0,
                                resId: file.file.id,
                                thumbUrl: file.file.thumb_url,
                                categoryId: _this3.category.id
                              };

                              if (_this3.isCocosModelAnimation) {
                                params['prefix'] = _this3.resource.prefix;
                              }
                              changeResourceByGltf = _this3.isCocosModelAnimation ? _this3.replaceAnimationByGltf : _this3.openModelEditorByGltf;


                              changeResourceByGltf(params);
                              submitCallback();
                            }

                          case 20:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this3, [[5, 14]]);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }();

              case 21:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    handleBeforeUpload: function handleBeforeUpload() {
      this.updateCurrentCategory(this.category);
      this.updateCurrentResource(this.resource);
    }
  })
};